import { HttpServiceConfigurator } from '@web-shared/services/http-service/http-service-configurator';
import { createHttpService } from '@web-shared/services/http-service/http-service-factory';
import { baseUrl } from '../config/env';

class AppHttpConfigurator extends HttpServiceConfigurator {
  getHttpClientConfig() {
    const baseConfig = super.getHttpClientConfig();
    return {
      ...baseConfig,
      baseURL: baseUrl,
    };
  }
}

export const httpService = createHttpService(new AppHttpConfigurator());
